const convertToUTC = date => {
  if (!date) {
    return date
  }

  let dateUTC

  if (date instanceof Date) {
    dateUTC = date
  } else if (typeof date === 'number') {
    dateUTC = new Date(date)
  }

  return new Date(dateUTC.toUTCString().slice(0, -4))
}

export {
  convertToUTC
}



// WEBPACK FOOTER //
// ./client/utils/dateUtils.js